import { Component, EventEmitter, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AttendenceService } from '../../shared/services/attendence.service';
import { AuthService } from '../../shared/services/auth.service';
import { OpenSnackBarService } from '../../shared/services/snackBar.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BarcodeFormat } from '@zxing/library';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [CommonModule, NgbDropdownModule, MatFormFieldModule, MatInputModule, ZXingScannerModule, FormsModule, ReactiveFormsModule]
})
export class HeaderComponent implements OnInit, OnDestroy {
  checkInModal: NgbModalRef = {} as NgbModalRef;
  changePasswordModal: NgbModalRef = {} as NgbModalRef;
  checkedInUser: any;
  wayToCheckIn = 'manual';
  checkedInCode: any;
  scannedCodeOnce: number = 0;
  
  // Camera properties
  hasCameraPermission = false;
  cameraAvailable = false;
  scannerEnabled = false;
  availableDevices: MediaDeviceInfo[] = [];
  currentDevice: MediaDeviceInfo | undefined;
  allowedFormats = [BarcodeFormat.QR_CODE, BarcodeFormat.CODE_128, BarcodeFormat.DATA_MATRIX];

  userType :  any = '';
  changePasswordForm: FormGroup;
  changePasswordLoadingFlag = false;
  @Input()
  heading: string = '';
  constructor(private router: Router,
    private attendenceService: AttendenceService,
    private authService: AuthService,
    private modal: NgbModal,
    private fb: FormBuilder,
    private openSnackBarService: OpenSnackBarService) {

    this.userType = localStorage.getItem("auth_role");
    // console.log(this.userType);
    this.changePasswordForm = this.fb.group({
      old_password: [null, Validators.compose([Validators.required])],
      new_password: [null, Validators.compose([Validators.required])],
      confirm_password: [null, Validators.compose([Validators.required])],
    });

  }
  
  ngOnInit(): void {
    // Simple check for camera availability
    this.checkCameraAvailability();
  }
  
  ngOnDestroy(): void {
    if (this.checkInModal && this.checkInModal.close) {
      this.checkInModal.close();
    }
    if (this.changePasswordModal && this.changePasswordModal.close) {
      this.changePasswordModal.close();
    }
  }
  
  /**
   * Checks if the device has camera capabilities
   */
  checkCameraAvailability(): void {
    // Simply check if the API exists without requesting permission yet
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      console.log('Camera API available');
      this.cameraAvailable = true;
      // Don't request permission until user selects camera option
    } else {
      this.cameraAvailable = false;
      this.hasCameraPermission = false;
      console.warn('Camera access is not supported in this browser or device.');
    }
  }
  
  /**
   * Handler for camera permission events
   */
  onHasPermission(has: boolean): void {
    this.hasCameraPermission = has;
    console.log('Permission response from scanner:', has);
    if (!has) {
      console.warn('Camera permission denied or not available.');
      // Don't force manual mode immediately
    }
  }
  
  /**
   * Handler for device change events
   */
  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    if (devices && devices.length > 0) {
      this.currentDevice = devices[0];
    }
  }
  
  /**
   * Handler for camera errors
   */
  onCameraError(error: Error): void {
    console.error('Camera error:', error);
    this.openSnackBarService.openSnackBar('fail', 'Camera could not be accessed. Please try manual check-in.');
    this.wayToCheckIn = 'manual';
  }
  @Output()
  toggleSidenav = new EventEmitter<void>();
  logout() {
    this.authService.logout().subscribe(res => {
      localStorage.clear();
      this.router.navigateByUrl('/');
    },
    (err: any) => {
      this.openSnackBarService.openSnackBar('fail', err.error);
    });
  }
  toUserProfile() {
    this.router.navigateByUrl('/user-profile');
  }
  openCheckInModal(checkInModal :  any) {
    // Reset scanner state and check-in code before opening modal
    this.wayToCheckIn = 'manual';
    this.scannerEnabled = false;
    this.checkedInCode = '';
    this.scannedCodeOnce = 0;
    
    // Open the modal
    this.checkInModal = this.modal.open(checkInModal, { size: 'lg' });
    
    // Check camera availability again when modal opens
    this.checkCameraAvailability();
  }
  checkInWay(way : any) {
    this.wayToCheckIn = way;
    if (way === 'camera') {
      if (!this.cameraAvailable) {
        this.openSnackBarService.openSnackBar('fail', 'Camera is not available on this device or browser.');
        this.wayToCheckIn = 'manual';
        return;
      }
      
      // Simply enable the scanner and let the component handle permissions
      this.scannerEnabled = true;
    } else {
      this.scannerEnabled = false;
    }
  }
  CheckInUser() {
    // console.log(this.checkedInCode);
    
    this.attendenceService.checkInUser(this.checkedInCode).subscribe(
      (res: any) => {
        // console.log(res)
        this.checkInModal.close();
        this.router.navigateByUrl(`${this.userType == "checkin" ? 'checkin' : ''}/client-management/client-profile/code/${res.code}`);
        this.checkedInCode = ""
      },
      (err: any) => {
        this.openSnackBarService.openSnackBar('fail', err.error);
      }
    );
  }
  integrateWithOutlook() {
    this.authService.integrateWithOutlook().subscribe(
      (res: any) => {
        // console.log(res);

        window.open(res ,"_target");
      }, err => {
        this.openSnackBarService.openSnackBar('fail', err.error);
      }
    );
  }
  scanSuccess(value :  any) {
    this.scannedCodeOnce++;
    if (this.scannedCodeOnce == 1) {
      this.attendenceService.checkInUser(value).subscribe(
        (res: any) => {
          // console.log(res)
          this.checkInModal.close();
          this.router.navigateByUrl(`${this.userType == "checkin" ? 'checkin' : ''}/client-management/client-profile/code/${res.code}`);
          this.scannedCodeOnce = 0
        },
        (err: any) => {
          this.openSnackBarService.openSnackBar('fail', err.error);
        }
      );
    }

  }
  /**
   * Explicitly request camera permission
   */
  requestCameraPermission(): void {
    // Simply enable the scanner - it will handle permission requests
    this.scannerEnabled = true;
  }
  
  closeCheckInModal() {
    this.checkInModal.close();
  }
  changePassword(changePasswordModal : any) {
    this.changePasswordForm.reset();
    this.changePasswordModal = this.modal.open(changePasswordModal, { size: 'lg' });
  }
  closeChangePasswordModal() {
    this.changePasswordModal.close();
  }
  changePasswordSubmit() {
    let body = this.changePasswordForm.value;
    this.changePasswordLoadingFlag = true;
    body["_method"] = "PUT"

    this.authService.updateUserPassword(body).subscribe(res => {

      this.changePasswordForm.reset();
      this.changePasswordLoadingFlag = false;
      this.closeChangePasswordModal();
      this.openSnackBarService.openSnackBar('success', "Password successfully changed");
    },
      err => {
        this.changePasswordLoadingFlag = false;
        this.openSnackBarService.openSnackBar('fail', err.error);
      });
  }
}
